import { Video, VideoPreviewLabel } from '@giphy/react-giphy-brand'
import React, { useEffect } from 'react'
import { trending } from 'shared/api/videos'
import SectionHeader from 'shared/components/section-header'
import VideoPreview from 'shared/components/video-preview-thumbnail'
import { useGifPaginator } from 'shared/hooks/use-gif-paginator'
import styled from 'styled-components'
import VideoPlayerAnalytics from 'shared/components/video-player/analytics'
import url from 'url'
import { useHistory } from 'react-router'

const MAIN_VIDEO_WIDTH = 739
const SMALL_VIDEO_WIDTH = 287
const ASPECT_RATIO = 16 / 9

const Header = styled.a`
    font-family: nexaregular, interface, 'Helvetica Neue', helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 36px;
    line-height: 36px;
    padding: 0px;

    span {
        font-family: nexablack;
    }
`

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 6px;
`

const VideoLogo = styled.div`
    width: 25px;
    height: 25px;
    background-image: url(/static/img/svg/play-button.svg);
    background-size: 25px;
    display: inline-block;
    position: relative;
    top: 2px;
`

const VideoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
`
const Previews = styled.div`
    display: flex;
    flex-direction: column;
`

const PrimaryVideoContainer = styled.div`
    display: flex;
    flex-direction: column;

    img {
        object-fit: cover;
    }
`

const LastVideoPreview = styled(VideoPreview)`
    margin-top: auto;
`

const HomepageVideos = () => {
    // paginator for videos
    const [videos, fetchVideos] = useGifPaginator((offset: number) => trending({ offset }))
    const [firstVideo, secondVideo, thirdVideo] = videos
    const history = useHistory()

    useEffect(() => {
        // fetch videos for carousel
        fetchVideos()
    }, [])

    if (!firstVideo) {
        return null
    }
    const { path } = url.parse(firstVideo.url)
    return (
        <>
            <HeaderContainer>
                <Header href="/videos/">
                    <span>GIPHY</span> Videos <VideoLogo />
                </Header>
                <SectionHeader label="See All Videos" url="/videos" />
            </HeaderContainer>
            <VideoContainer>
                <PrimaryVideoContainer>
                    <Video
                        gif={firstVideo}
                        width={MAIN_VIDEO_WIDTH}
                        height={MAIN_VIDEO_WIDTH / ASPECT_RATIO}
                        noCutout
                        noShare
                        events={new VideoPlayerAnalytics(firstVideo.id)}
                    />
                    <VideoPreviewLabel
                        href={firstVideo.url}
                        onClick={() => history.push(path)}
                        showAttribution
                        title={firstVideo.title}
                        user={firstVideo.user}
                        width={MAIN_VIDEO_WIDTH}
                    />
                </PrimaryVideoContainer>
                <Previews>
                    {secondVideo && (
                        <VideoPreview
                            gif={secondVideo}
                            width={SMALL_VIDEO_WIDTH}
                            height={SMALL_VIDEO_WIDTH / ASPECT_RATIO}
                        />
                    )}
                    {thirdVideo && (
                        <LastVideoPreview
                            gif={thirdVideo}
                            width={SMALL_VIDEO_WIDTH}
                            height={SMALL_VIDEO_WIDTH / ASPECT_RATIO}
                        />
                    )}
                </Previews>
            </VideoContainer>
        </>
    )
}

export default HomepageVideos
